import script from "./UploadBusiness.vue?vue&type=script&lang=ts&setup=true"
export * from "./UploadBusiness.vue?vue&type=script&lang=ts&setup=true"

import "./UploadBusiness.vue?vue&type=style&index=0&id=1ba12d56&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ba12d56"]])

export default __exports__